import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {Component, Input} from '@angular/core';

@Component({
  selector: 'dcp-loading-page',
  templateUrl: './loading-page.component.html',
  styleUrls: ['./loading-page.component.scss'],
})
export class LoadingPageComponent {
  @Input() loadingText = 'Loading';
  @Input({transform: coerceBooleanProperty}) fullScreen = false;
}
